module.exports = __webpack_public_path__ + "static/media/subject_comparision.5ccfc8b3.svg";